import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { defaultLimit, defaultOffset } from 'config/Api.Config';
import { useState } from 'react';

export interface ClaimFilters extends Api.IDefaultListRequest {
  id?: number[];
  applicationId?: number;
  permissionId?: number;
  productId?: number[];
  makeId?: number[];
  ownerId?: number[];
  claimOwnerId?: number[];
  contractId?: number[];
  dealerId?: number[];
  distributorId?: number[];
  reporterId?: number;
  claimReporterId?: number;
  statusCode?: string[];
  claimStatusCode?: string[];
  claimJobStatusCode?: string[];
  createdAtFromDateUtc?: string;
  createdAtToDateUtc?: string;
  showMyClaims?: boolean;
  includeOwnerless?: boolean;
  includeOwnerlessClaim?: boolean;
}

export default function useClaimFilters() {
  const { user, permissions } = useAuthStore();
  const [filters, setFilters] = useState<ClaimFilters>({});

  const defaultFilters = {
    distributorId: user?.distributorId ? [user.distributorId] : undefined,
    reporterId: permissions?.VIEW_ONLY_OWNED_CLAIMS ? user?.id : undefined,
    claimReporterId: permissions?.VIEW_ONLY_OWNED_CLAIMS ? user?.id : undefined,
    dealerId: user?.dealers?.map((it) => it.id) ?? [],
    limit: defaultLimit,
    offset: defaultOffset,
  };

  function setClaimJobFilters(filters: ClaimFilters) {
    if (!filters) return {};

    const newFilters = {
      ...filters,
      includeOwnerless: undefined,
      claimJobStatusCode: undefined,
      reporterId: undefined,
      orderBy: undefined,
      orderType: undefined,
      thenBy: undefined,
      thenType: undefined,
      claimStatusCode: filters.statusCode,
      claimReporterId: filters.reporterId,
      statusCode: filters.claimJobStatusCode,
      claimOwnerId: filters.ownerId,
      includeOwnerlessClaim: filters.includeOwnerless,
    };
    setFilters(newFilters);

    return { list: newFilters };
  }

  function setClaimFilters(filters: ClaimFilters) {
    if (!filters) return {};

    const newFilters = {
      ...filters,
      claimStatusCode: undefined,
      includeOwnerlessClaim: undefined,
      claimReporterId: undefined,
      orderBy: undefined,
      orderType: undefined,
      thenBy: undefined,
      thenType: undefined,
      reporterId: filters.claimReporterId,
      claimJobStatusCode: filters.statusCode,
      statusCode: filters.claimStatusCode,
      ownerId: filters.claimOwnerId,
      includeOwnerless: filters.includeOwnerlessClaim,
    };
    setFilters(newFilters);

    return { list: newFilters };
  }

  return {
    filters,
    defaultFilters,
    setClaimFilters,
    setClaimJobFilters,
  };
}
